// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Theme__Color = require("../../../reason/common/Theme/Theme__Color.bs.js");
var SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RenewRentalNeedMutation = require("../ClientPage/RenewRentalNeedMutation.bs.js");
var MyClientsWidgetRowLayout = require("./MyClientsWidgetRowLayout.bs.js");
var OwnRentalNeedStatusLabel = require("../OwnRentalNeedStatusLabel.bs.js");
var WithdrawRentalNeedDialog = require("../ClientPage/WithdrawRentalNeedDialog.bs.js");
var MyClientsWidgetDeleteDialog = require("./MyClientsWidgetDeleteDialog.bs.js");
var MarkRentalNeedAsRentedDialog = require("../ClientPage/MarkRentalNeedAsRentedDialog.bs.js");
var MyClientsWidgetRenter_renter_graphql = require("../../../__generated__/MyClientsWidgetRenter_renter_graphql.bs.js");
var MyClientsWidgetRenter_Menu_renter_graphql = require("../../../__generated__/MyClientsWidgetRenter_Menu_renter_graphql.bs.js");
var MyClientsWidgetRenter_name_renter_graphql = require("../../../__generated__/MyClientsWidgetRenter_name_renter_graphql.bs.js");
var MyClientsWidgetRenter_status_renter_graphql = require("../../../__generated__/MyClientsWidgetRenter_status_renter_graphql.bs.js");

var convertFragment = MyClientsWidgetRenter_Menu_renter_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRenter_Menu_renter_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_Menu_renter_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetRenter_Menu_renter_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRenter_Menu_renter_graphql.node, convertFragment, fRef);
}

var RenterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyClientsWidgetRenter$Menu(props) {
  var renter = use(props.renter);
  var rentalNeed = renter.rentalNeed;
  var hasActivityReport = Core__Array.keepSome(Core__Option.getOr(Core__Option.map(renter.rentalNeed.broadcasts, (function (connection) {
                    return connection.edges;
                  })), [])).some(function (edge) {
        var match = edge.node.activityReport;
        if (match.__typename === "ActivityReportV5") {
          return true;
        } else {
          return false;
        }
      });
  var matchesCount = Core__Option.getOr(Core__Option.map(renter.rentalNeed.matches, (function (m) {
              return m.totalCount;
            })), 0);
  var match = React.useState(function () {
        return false;
      });
  var setDeleteDialogOpen = match[1];
  var match$1 = SystemMessages.useSystemMessages();
  var addMessage = match$1.addMessage;
  var handleRenewingError = function () {
    addMessage(SystemMessages.Message.make(undefined, "error", "There was an error making the rental need active. Please try again...", 5000, undefined, undefined));
  };
  var match$2 = RenewRentalNeedMutation.use(rentalNeed.nodeId, handleRenewingError, true);
  var makeRentalNeedActiveIsLoading = match$2[1];
  var makeRentalNeedActive = match$2[0];
  var match$3 = React.useState(function () {
        return false;
      });
  var setWithdrawDialogOpen = match$3[1];
  var match$4 = React.useState(function () {
        return false;
      });
  var setMarkRentedDialogOpen = match$4[1];
  var match$5 = renter.rentalNeed.status;
  var tmp;
  switch (match$5.__typename) {
    case "ActiveRentalNeed" :
        tmp = match$5.isRenewable ? "Renew or change status" : "Change status";
        break;
    case "ExpiredRentalNeed" :
        tmp = "Renew or change status";
        break;
    default:
      tmp = "Change status";
  }
  var match$6 = renter.rentalNeed.status;
  var tmp$1;
  var exit = 0;
  switch (match$6.__typename) {
    case "ActiveRentalNeed" :
        if (match$6.isRenewable) {
          exit = 1;
        } else {
          tmp$1 = null;
        }
        break;
    case "ExpiredRentalNeed" :
        exit = 1;
        break;
    default:
      tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: (function () {
                makeRentalNeedActive();
              }),
            isDisabled: makeRentalNeedActiveIsLoading,
            children: "Change to active"
          });
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
          onAction: (function () {
              makeRentalNeedActive();
            }),
          isDisabled: makeRentalNeedActiveIsLoading,
          children: "Renew property"
        });
  }
  var match$7 = renter.rentalNeed.status;
  var tmp$2;
  tmp$2 = match$7.__typename === "RentedRentalNeed" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
          onAction: (function () {
              setMarkRentedDialogOpen(function (param) {
                    return true;
                  });
            }),
          children: "Mark as rented"
        });
  var match$8 = renter.rentalNeed.status;
  var tmp$3;
  tmp$3 = match$8.__typename === "WithdrawnRentalNeed" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
          onAction: (function () {
              setWithdrawDialogOpen(function (param) {
                    return true;
                  });
            }),
          children: "Withdraw rental need"
        });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(WithdrawRentalNeedDialog.make, {
                      nodeId: rentalNeed.nodeId,
                      isOpen: match$3[0],
                      close: (function () {
                          setWithdrawDialogOpen(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsx(MarkRentalNeedAsRentedDialog.make, {
                      nodeId: rentalNeed.nodeId,
                      isOpen: match$4[0],
                      close: (function () {
                          setMarkRentedDialogOpen(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsx(MyClientsWidgetDeleteDialog.make, {
                      client: renter.fragmentRefs,
                      isOpen: match[0],
                      onCancel: (function () {
                          setDeleteDialogOpen(function (param) {
                                return false;
                              });
                        }),
                      onSuccess: (function () {
                          setDeleteDialogOpen(function (param) {
                                return false;
                              });
                        }),
                      connectionId: props.connectionId
                    }),
                JsxRuntime.jsxs(MenuV5.Menu.make, {
                      button: JsxRuntime.jsx(ButtonsV5.Button.make, {
                            className: "!border-none",
                            children: Caml_option.some(JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "ThreeDots",
                                      size: 16,
                                      color: Theme__Color.black
                                    }))
                          }),
                      children: [
                        JsxRuntime.jsx(MenuV5.MenuItem.make, {
                              href: "/client_needs/" + renter.rentalNeed.id + "/edit",
                              children: "Edit rental need"
                            }),
                        JsxRuntime.jsxs(MenuV5.Submenu.make, {
                              name: tmp,
                              children: [
                                tmp$1,
                                tmp$2,
                                tmp$3
                              ]
                            }),
                        matchesCount > 0 ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/my_clients/" + renter.id + "#matches",
                                children: "View matches (" + matchesCount.toString() + ")"
                              }) : null,
                        hasActivityReport ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/client_needs/" + renter.rentalNeed.id + "/report",
                                children: "View activity report"
                              }) : null,
                        JsxRuntime.jsx(MenuV5.MenuItem.make, {
                              onAction: (function () {
                                  setDeleteDialogOpen(function (param) {
                                        return true;
                                      });
                                }),
                              children: "Delete renter"
                            })
                      ]
                    })
              ]
            });
}

var Menu = {
  RenterFragment: RenterFragment,
  make: MyClientsWidgetRenter$Menu
};

var convertFragment$1 = MyClientsWidgetRenter_name_renter_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRenter_name_renter_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_name_renter_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetRenter_name_renter_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRenter_name_renter_graphql.node, convertFragment$1, fRef);
}

var RenterFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MyClientsWidgetRenter$Name(props) {
  var renter = use$1(props.renter);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: "Rental Need",
                            className: "text-gray-500 uppercase font-light"
                          }),
                      className: "flex gap-2"
                    }),
                JsxRuntime.jsx(ButtonsV5.Link.make, {
                      href: "my_clients/" + renter.id,
                      children: Caml_option.some(JsxRuntime.jsx("div", {
                                children: renter.displayName,
                                className: "text-lg"
                              }))
                    })
              ],
              className: "flex flex-col gap-1"
            });
}

var Name = {
  RenterFragment: RenterFragment$1,
  make: MyClientsWidgetRenter$Name
};

var convertFragment$2 = MyClientsWidgetRenter_status_renter_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRenter_status_renter_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_status_renter_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetRenter_status_renter_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRenter_status_renter_graphql.node, convertFragment$2, fRef);
}

var RenterFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MyClientsWidgetRenter$Status$WithoutErrorBoundary(props) {
  var renter = use$2(props.renter);
  return JsxRuntime.jsx(OwnRentalNeedStatusLabel.make, {
              rentalNeed: renter.rentalNeed.fragmentRefs
            });
}

var WithoutErrorBoundary = {
  RentalNeedStatusLabel: undefined,
  RenterFragment: RenterFragment$2,
  make: MyClientsWidgetRenter$Status$WithoutErrorBoundary
};

function MyClientsWidgetRenter$Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "rental need status",
              children: JsxRuntime.jsx(MyClientsWidgetRenter$Status$WithoutErrorBoundary, {
                    renter: props.renter
                  })
            });
}

var Status = {
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: MyClientsWidgetRenter$Status
};

var convertFragment$3 = MyClientsWidgetRenter_renter_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRenter_renter_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_renter_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetRenter_renter_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRenter_renter_graphql.node, convertFragment$3, fRef);
}

var RenterFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function MyClientsWidgetRenter(props) {
  var renter = use$3(props.renter);
  return JsxRuntime.jsx(MyClientsWidgetRowLayout.make, {
              name: JsxRuntime.jsx(MyClientsWidgetRenter$Name, {
                    renter: renter.fragmentRefs
                  }),
              status: JsxRuntime.jsx(MyClientsWidgetRenter$Status, {
                    renter: renter.fragmentRefs
                  }),
              menu: JsxRuntime.jsx(MyClientsWidgetRenter$Menu, {
                    renter: renter.fragmentRefs,
                    connectionId: props.connectionId
                  })
            });
}

var Layout;

var Components;

var Link;

var DeleteDialog;

var make = MyClientsWidgetRenter;

exports.Layout = Layout;
exports.Components = Components;
exports.Link = Link;
exports.DeleteDialog = DeleteDialog;
exports.Menu = Menu;
exports.Name = Name;
exports.Status = Status;
exports.RenterFragment = RenterFragment$3;
exports.make = make;
/* react Not a pure module */
